import { Route, Routes } from 'react-router-dom';

// components
import PageNotFound from './pages/PageNotFound';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import CompanyStatusGuard from './components/CompanyStatusGuard';
import DefaultLayout from './layouts/DefaultLayout';
import Registration from './pages/Registration';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Bandi from './pages/Bandi';
import BandiBeneficiario from './pages/BandiBeneficiario';
import DashboardBeneficiarioConfidi from './pages/DashboardBeneficiarioConfidi';
import DocumentsBeneficiary from './pages/DocumentsBeneficiary';
import CommunicationsBeneficiary from './pages/CommunicationsBeneficiary';
import StatsBeneficiary from './pages/StatsBeneficiary';
import UserActivity from './pages/UserActivity';
import Users from './pages/Users';
import AddCompany from './pages/AddCompany';
import ProfileCompany from './pages/ProfileCompany';
import Profile from './pages/Profile';
import ProfileBeneficiario from './pages/ProfileBeneficiario';
import BandoApplication from './pages/BandoApplication';
import Imieibandi from './pages/Imieibandi';
import SoccorsoIstruttorioPreInstructor from './pages/SoccorsoIstruttorioPreInstructor';
import SoccorsoEditPreInstructor from './pages/SoccorsoEditPreInstructor';
import SoccorsoAddPreInstructor from './pages/SoccorsoAddPreInstructor';
import BandoApplicationPreview from './pages/BandoApplicationPreview';
import DomandeArchivePreInstructor from './pages/DomandeArchivePreInstructor';
import DomandeArchive from './pages/DomandeArchive';
import DomandaEditPreInstructor from './pages/DomandaEditPreInstructor';
import SoccorsoEditBeneficiario from './pages/SoccorsoEditBeneficiario';
import DomandePreInstructor from './pages/DomandePreInstructor';
import DomandeBeneficiario from './pages/DomandeBeneficiario';
import Domande from './pages/Domande';
import BandiPreferredBeneficiario from './pages/BandiPreferredBeneficiario';
import RichiesteIntegrazioni from './pages/RichiesteIntegrazioni';
import BandoFlowEdit from './pages/BandoFlowEdit';
import BandoFormsPreview from './pages/BandoFormsPreview';
import BandoFormsEdit from './pages/BandoFormsEdit';
import BandoForms from './pages/BandoForms';
import BandoView from './pages/BandoView';
import BandoViewPreInstructor from './pages/BandoViewPreInstructor';
import BandoViewBeneficiario from './pages/BandoViewBeneficiario';
import BandoEdit from './pages/BandoEdit';
import DashboardPreInstructor from './pages/DashboardPreInstructor';
import BandiPreInstructor from './pages/BandiPreInstructor';
import FirstAccess from './pages/FirstAccess';
import SimpleLayout from './layouts/SimpleLayout';
import ManageSuppliers from './pages/ManageSuppliers';
import DocumentsEvaluatePreInstructor from './pages/DocumentsEvaluatePreInstructor';
import ManageSuppliersPreInstructor from './pages/ManageSuppliersPreInstructor';
import Assistenza from './pages/Assistenza';
import Ticket from './pages/Ticket';

const routes = ({role, chosenCompanyId}) => {
    return (
        <Routes>
            <Route element={<ProtectedRoute/>}>
                <Route element={<CompanyStatusGuard/>}>
                    <Route path="/primo-accesso" element={<SimpleLayout>
                        {'ROLE_CONFIDI' === role ? <FirstAccess/> : null}
                    </SimpleLayout>}/>
                    <Route path="/" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <Dashboard/> : null}
                        {'ROLE_CONFIDI' === role ? <DashboardBeneficiarioConfidi/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <DashboardPreInstructor/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <DashboardInstructorManager/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/moduli" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <Bandi/> : null}
                        {'ROLE_CONFIDI' === role ? <BandiBeneficiario/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <BandiPreInstructor/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <BandiPreInstructor/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/moduli/:id" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <BandoEdit/> : null}
                        {'ROLE_CONFIDI' === role ? <BandoViewBeneficiario/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <BandoViewPreInstructor/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <BandoViewPreInstructor/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/moduli/:id/preview" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <BandoView/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/moduli/:id/preview-evaluation" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <BandoView/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/moduli/:id/forms" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <BandoForms/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/* {'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/moduli/:id/forms/:formId" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <BandoFormsEdit/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/moduli/:id/forms/:formId/preview" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <BandoFormsPreview/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/moduli/:id/flow" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <BandoFlowEdit/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/moduli-osservati" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                        {'ROLE_CONFIDI' === role ? <BandiPreferredBeneficiario/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/domande" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <Domande/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <DomandePreInstructor/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <DomandeInstructorManager/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/domande/:id/" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <DomandaEditPreInstructor/> : null}
                        {'ROLE_CONFIDI' === role ? <SoccorsoEditBeneficiario/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <DomandaEditPreInstructor/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <DomandaEditPreInstructor/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/domande/:id/preview" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <BandoApplicationPreview/> : null}
                        {'ROLE_CONFIDI' === role ? <BandoApplicationPreview/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <BandoApplicationPreview/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <BandoApplicationPreview/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/archivio" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <DomandeArchive/> : null}
                        {'ROLE_CONFIDI' === role ? <DomandeBeneficiario/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <DomandeArchivePreInstructor/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <DomandeArchive/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/archivio/:id/preview" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <BandoApplicationPreview/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <BandoApplicationPreview/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <BandoApplicationPreview/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/domande/:id/aggiungi-soccorso" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <SoccorsoAddPreInstructor/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/domande/:id/soccorso/:amendmentId" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <SoccorsoEditPreInstructor/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <SoccorsoEditPreInstructor/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/soccorso-istruttorio/" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <SoccorsoIstruttorioPreInstructor/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <SoccorsoIstruttorioInstructorManager/> : null}*/}
                    </DefaultLayout>}/>
                    {/*<Route path="/mie-domande" element={<DefaultLayout>
                    {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                    {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                    {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                    {'ROLE_INSTRUCTOR_MANAGER' === role ? <DomandeMieInstructorManager/> : null}
                </DefaultLayout>}/>
                <Route path="/mie-domande/:id/" element={<DefaultLayout>
                    {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                    {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                    {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                    {'ROLE_INSTRUCTOR_MANAGER' === role ? <DomandaEditInstructorManager/> : null}
                </DefaultLayout>}/>*/}
                    {/*<Route path="/mie-domande/:id/aggiungi-soccorso" element={<DefaultLayout>
                    {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                    {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                    {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                    {'ROLE_INSTRUCTOR_MANAGER' === role ? <SoccorsoAddInstructorManager/> : null}
                </DefaultLayout>}/>
                <Route path="/mie-domande/:id/soccorso/:amendmentId" element={<DefaultLayout>
                    {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                    {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                    {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                    {'ROLE_INSTRUCTOR_MANAGER' === role ? <SoccorsoEditInstructorManager/> : null}
                </DefaultLayout>}/>*/}
                    <Route path="/mio-soccorso-istruttorio/" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <SoccorsoIstruttorioMioInstructorManager/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/imieimoduli" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                        {'ROLE_CONFIDI' === role ? <Imieibandi/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/richieste-integrazioni" element={<DefaultLayout>
                        {'ROLE_CONFIDI' === role ? <RichiesteIntegrazioni/> : null}
                    </DefaultLayout>}/>
                    <Route path="/imieimoduli/:id/" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                        {'ROLE_CONFIDI' === role ? <BandoApplication/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/profilo" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <Profile/> : null}
                        {'ROLE_CONFIDI' === role ? <ProfileBeneficiario/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <Profile/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <Profile/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/profilo-aziendale" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                        {'ROLE_CONFIDI' === role ? (chosenCompanyId > 0 ? <ProfileCompany/> : <PageNotFound/>) : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    {/*<Route path="/agguingi-azienda" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                        {'ROLE_CONFIDI' === role ? <AddCompany/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}
                    </DefaultLayout>}/>*/}
                    <Route path="/utenti" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <Users/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/utenti/:id" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <UserActivity/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/fornitori" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <ManageSuppliers/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <ManageSuppliersPreInstructor/> : null}
                        {'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}
                    </DefaultLayout>}/>
                    <Route path="/fornitori/:id" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <DocumentsEvaluatePreInstructor/> : null}
                        {'ROLE_CONFIDI' === role ? <PageNotFound/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <DocumentsEvaluatePreInstructor/> : null}
                        {'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}
                    </DefaultLayout>}/>
                    <Route path="/stats" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                        {'ROLE_CONFIDI' === role ? <StatsBeneficiary/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/documenti" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <PageNotFound/> : null}
                        {'ROLE_CONFIDI' === role ? <DocumentsBeneficiary/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <PageNotFound/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <PageNotFound/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/comunicazioni" element={<DefaultLayout>
                        {'ROLE_CONFIDI' === role ? <CommunicationsBeneficiary/> : null}
                    </DefaultLayout>}/>
                    <Route path="/assistenza" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <Assistenza/> : null}
                        {'ROLE_CONFIDI' === role ? <Assistenza/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <Assistenza/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <DashboardInstructorManager/> : null}*/}
                    </DefaultLayout>}/>
                    <Route path="/assistenza/ticket/:id" element={<DefaultLayout>
                        {'ROLE_SUPER_ADMIN' === role ? <Ticket/> : null}
                        {'ROLE_CONFIDI' === role ? <Ticket/> : null}
                        {'ROLE_PRE_INSTRUCTOR' === role ? <Ticket/> : null}
                        {/*{'ROLE_INSTRUCTOR_MANAGER' === role ? <DashboardInstructorManager/> : null}*/}
                    </DefaultLayout>}/>
                </Route>
            </Route>
            <Route exact path="/reset-password" element={<SimpleLayout><ResetPassword/></SimpleLayout>}/>
            <Route exact path="/login" element={<SimpleLayout><Login/></SimpleLayout>}/>
            <Route exact path="/registration" element={<SimpleLayout><Registration/></SimpleLayout>}/>
            <Route path="*" element={<SimpleLayout><PageNotFound/></SimpleLayout>}/>
        </Routes>
    );
};

export default routes;
